// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5680":"8e476dc8","7180":"c0f81b4c","8844":"a82c18e7","8880":"d46268cc"}[chunkId] + ".css";
};